import { request } from "../http/api-client";
import type { ApiKey } from "../types";

function decodeJwt(jwt: string): any | null {
  try {
    const parts = jwt.split(".");
    if (parts.length < 2) return null;
    const payload = parts[1].replace(/-/g, "+").replace(/_/g, "/");
    const json = atob(payload);
    return JSON.parse(json);
  } catch { return null; }
}

function getMerchantId(): string | null {
  try {
    const token = localStorage.getItem("finpay-token");
    if (!token) return null;
    const p = decodeJwt(token);
    return p?.merchantId || null;
  } catch { return null; }
}

export async function listApiKeys(): Promise<ApiKey[]> {
  const merchantId = getMerchantId();
  if (!merchantId) throw new Error("Missing merchantId");
  const res = await request<{ success: boolean; data: ApiKey[] }>(`/api/v1/merchants/${merchantId}/api-keys`, { method: "GET" });
  return res.data || [];
}

export async function createApiKey(payload: { name: string; environment: "live" | "test"; permissions: string[]; expiresAt?: string }) {
  const merchantId = getMerchantId();
  if (!merchantId) throw new Error("Missing merchantId");
  const res = await request<{ success: boolean; data: ApiKey }>(`/api/v1/merchants/${merchantId}/api-keys`, {
    method: "POST",
    body: {
      name: payload.name,
      environment: payload.environment,
      permissions: payload.permissions,
      expiresAt: payload.expiresAt,
    },
  });
  return res.data;
}

export async function deleteApiKey(id: string): Promise<void> {
  const merchantId = getMerchantId();
  if (!merchantId) throw new Error("Missing merchantId");
  await request(`/api/v1/merchants/${merchantId}/api-keys/${id}`, { method: "DELETE" });
}
